"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _default;
  }
});
const _createPlugin = /*#__PURE__*/_interop_require_default(require("../util/createPlugin"));
function _interop_require_default(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const _default = _createPlugin.default;